"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./defineProperty-b53f90b9.js"),
  t = require("./extends-fa579b0f.js"),
  a = require("react"),
  n = require("styled-components"),
  r = require("prop-types"),
  l = require("./assistiveText-80858a8d.js"),
  i = require("./link-8b1ebef7.js"),
  d = require("./typography-fb2881fe.js"),
  o = require("./taggedTemplateLiteral-97b463ad.js"),
  u = require("polished/lib/helpers/rem"),
  s = require("./grid-965d799c.js"),
  p = require("./sectionContainer-2a921e1c.js");
function m(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var g,
  f,
  c,
  h,
  T,
  b,
  y,
  k,
  O,
  P,
  j,
  v,
  L,
  _,
  q,
  x = m(a),
  w = m(n),
  E = m(r),
  C = m(u),
  I = w["default"](s.Col)(g || (g = o._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.largeUp();
    return n.css(f || (f = o._taggedTemplateLiteral(["\n      ", "\n    "])), t && "\n        display: flex;\n        flex: 0 0 auto;\n        padding: 0;\n      ");
  }),
  R = w["default"](s.Col)(c || (c = o._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.largeUp();
    return n.css(h || (h = o._taggedTemplateLiteral(["\n      ", "\n    "])), t && "\n        display: flex;\n        flex: 0 1 auto;\n        flex-wrap: wrap;\n        padding: 0;\n      ");
  }),
  V = w["default"](i.LinkComponent)(T || (T = o._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.largeUp(),
      a = C["default"](15);
    return n.css(b || (b = o._taggedTemplateLiteral(["\n      margin-right: ", ";\n      margin-left: ", ";\n    "])), a, t ? a : 0);
  }),
  N = w["default"].li(y || (y = o._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.largeUp();
    return n.css(k || (k = o._taggedTemplateLiteral(["\n      display: ", ";\n    "])), t ? "inline" : "block");
  }),
  U = w["default"](s.Row)(O || (O = o._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.largeUp();
    return n.css(P || (P = o._taggedTemplateLiteral(["\n      ", "\n    "])), t && "\n        display: flex;\n        flex-wrap: unset;\n        flex-direction: row;\n      ");
  }),
  B = w["default"](p.SectionContainerComponent)(j || (j = o._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme,
      a = e.disableTopPadding,
      r = t.mediumUp() ? C["default"](48) : C["default"](32);
    return a && (r = 0), n.css(v || (v = o._taggedTemplateLiteral(["\n      padding-top: ", ";\n    "])), r);
  }),
  D = w["default"](d.TypographyComponent)(L || (L = o._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme,
      a = e.lastItem,
      r = e.themeType,
      l = t.largeUp();
    return n.css(_ || (_ = o._taggedTemplateLiteral(["\n      padding-bottom: 0;\n      ", "\n      display: inline-block;\n      ::after {\n        ", ";\n        ", ";\n      }\n    "])), l && "white-space: nowrap;", !a && l && "content: ' | ';", "darkTheme" === r && "color: ".concat(t.colors.text.darkTheme["default"]));
  }),
  A = w["default"].ul(q || (q = o._taggedTemplateLiteral(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"])));
function S(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), a.push.apply(a, n);
  }
  return a;
}
function z(t) {
  for (var a = 1; a < arguments.length; a++) {
    var n = null != arguments[a] ? arguments[a] : {};
    a % 2 ? S(Object(n), !0).forEach(function (a) {
      e._defineProperty(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : S(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
var F = function F(e) {
  var a = e.backgroundVariant,
    n = e.className,
    r = e.disableBottomPadding,
    i = e.disableTopPadding,
    o = e.linkItems,
    u = e.moduleName,
    s = e.moduleVariation,
    p = e.sectionId,
    m = e.themeType;
  return x["default"].createElement(B, {
    id: p,
    backgroundVariant: a,
    className: n,
    disableBottomPadding: r,
    disableTopPadding: i,
    moduleName: u,
    moduleVariation: s,
    themeType: m
  }, x["default"].createElement(l.AssistiveTextComponent, {
    component: "h2"
  }, "Related links"), x["default"].createElement(U, {
    align: "center"
  }, x["default"].createElement(I, {
    medium: 3,
    mediumOffset: 2,
    large: 12,
    largeOffset: 0
  }, x["default"].createElement(d.TypographyComponent, {
    disableBottomPadding: !0,
    themeType: m,
    uppercase: !0,
    weight: 500
  }, "Related links:")), x["default"].createElement(R, {
    medium: 7,
    large: 12
  }, o && x["default"].createElement(A, null, o.map(function (e, a) {
    return x["default"].createElement(N, {
      key: "list-item-".concat(e.linkId)
    }, " ", x["default"].createElement(D, {
      component: "span",
      lastItem: a === o.length - 1,
      themeType: m,
      variant: "p"
    }, x["default"].createElement(V, t._extends({
      id: e.linkId
    }, e, {
      themeType: m,
      variant: "primaryDeemphasize"
    }), e.linkText, " ")));
  })))));
};
F.propTypes = {
  backgroundVariant: E["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  className: E["default"].string,
  disableBottomPadding: E["default"].bool,
  disableTopPadding: E["default"].bool,
  linkItems: E["default"].arrayOf(E["default"].shape(z(z({}, i.linkPropTypes), {}, {
    linkId: E["default"].string.isRequired,
    linkText: E["default"].oneOfType([E["default"].string, E["default"].object]).isRequired
  }))).isRequired,
  moduleName: E["default"].string,
  moduleVariation: E["default"].string,
  sectionId: E["default"].string.isRequired,
  themeType: E["default"].oneOf(["lightTheme", "darkTheme"])
}, F.defaultProps = {
  backgroundVariant: "lightA",
  disableBottomPadding: !1,
  disableTopPadding: !1,
  moduleName: "related-links",
  moduleVariation: "A",
  sectionId: "related-links",
  themeType: "lightTheme"
};
var G = n.withTheme(F);
exports.RelatedLinks = G;